class TcjAnnouncementBar extends HTMLElement {
  connectedCallback() {
    const key = this.dataset.dismissKey || 'tcj-anno-dismissed-v2';
    try {
      const dismissedUntil = parseInt(localStorage.getItem(key) || '0', 10);
      if (Number.isFinite(dismissedUntil) && dismissedUntil > Date.now()) {
        this.remove();
        return;
      }
    } catch (e) {
      // localStorage blocked, render anyway
    }

    this.hidden = false;
    this._messages = Array.from(this.querySelectorAll('.tcj-anno__msg'));
    this._index = 0;
    this._interval = parseInt(this.dataset.intervalMs || '6000', 10);
    this._fadeMs = 360;

    if (this._messages.length > 1) {
      this._start();
    }

    const closeBtn = this.querySelector('.tcj-anno__close');
    if (closeBtn) closeBtn.addEventListener('click', () => this._dismiss(key));

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this._stop();
      else this._start();
    });
  }

  disconnectedCallback() { this._stop(); }

  _advance() {
    if (!this._messages || this._messages.length < 2) return;
    const prev = this._messages[this._index];
    const nextIndex = (this._index + 1) % this._messages.length;
    const next = this._messages[nextIndex];

    if (prev) prev.removeAttribute('data-active');

    window.setTimeout(() => {
      if (next) next.setAttribute('data-active', '');
      this._index = nextIndex;
    }, this._fadeMs);
  }

  _start() {
    if (this._timer || !this._messages || this._messages.length < 2) return;
    this._timer = window.setInterval(() => this._advance(), this._interval);
  }

  _stop() {
    if (this._timer) {
      window.clearInterval(this._timer);
      this._timer = null;
    }
  }

  _dismiss(key) {
    const days = parseInt(this.dataset.dismissDays || '7', 10);
    const until = Date.now() + days * 24 * 60 * 60 * 1000;
    try { localStorage.setItem(key, String(until)); } catch (e) { /* noop */ }
    this._stop();
    this.style.transition = 'opacity 0.25s ease, max-height 0.3s ease, padding 0.3s ease';
    this.style.opacity = '0';
    this.style.maxHeight = this.offsetHeight + 'px';
    requestAnimationFrame(() => {
      this.style.maxHeight = '0px';
      this.style.padding = '0';
      this.style.minHeight = '0';
    });
    window.setTimeout(() => this.remove(), 320);
  }
}

if (!customElements.get('tcj-announcement-bar')) {
  customElements.define('tcj-announcement-bar', TcjAnnouncementBar);
}
